import { themes } from "./generated-new";
export {
  themes
};
//# sourceMappingURL=themes.js.map
